<div class="card kpi-blue">
    <div class="card-body kpi-card">
        <h5 class="card-title">Rendement brut <i class="fa fa-question-circle" matTooltipClass="tooltip-button" matTooltip="Rendement brut = 12 * Total des loyers / Total du projet"></i></h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- %</ng-container>
            <ng-container *ngIf="!preview">
                {{ favorite.efficiency_brut | number: '1.1-1' }} %
            </ng-container>
        </p>
    </div>
</div>
